import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {EnumData} from "../../../../api/enum/enum.model";
import {City, States} from "../../../../api/enum/city-state.model";

@Component({
    selector: 'app-address-section',
    imports: [ReactiveFormsModule],
    templateUrl: './address-section.component.html'
})
export class AddressSectionComponent {
    @Input() group!: FormGroup;
    @Input() addressType: EnumData[] = [];
    @Input() states: States[] = [];
    @Input() cities: City[] = [];
    @Output() numbersOnly = new EventEmitter<any>();
}
